import script from "./OverviewAlertDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewAlertDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewAlertDetailPage.vue?vue&type=style&index=0&id=460d099d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460d099d"]])

export default __exports__